__turbopack_context__.v({
  "groupWrap": "KcQoHW_groupWrap",
  "highlightedComment": "KcQoHW_highlightedComment",
  "repliesIndicator": "KcQoHW_repliesIndicator",
  "replyInset": "KcQoHW_replyInset",
});
